<template>
  <div class="commentary" v-if="value">
    <div class="block">
      <div class="header">
        <div class="c-g left">
          <span class="c-l title">分析结果</span>
          <span v-if="isContrast" class="c-v other">（病历2对比病历1）</span>
          <span v-else class="c-v other"
            >（{{ info.patientName }} {{ info.diagnosticName2 }}
            {{ info.updDtString }}）</span
          >
        </div>
        <div class="right">
          <Button
            :disabled="isEmpty"
            type="primary"
            size="small"
            @click="clone"
            >{{ info.isNew === 1 ? "下载分析结果" : "复制分析结果" }}</Button
          >
        </div>
      </div>
      <div class="black-body" v-if="!isEmpty">
        <div class="text-red" v-if="dialecticalData.explainType">
          需要讲解病因病机
        </div>
        <div
          class="text-green"
          v-else-if="dialecticalData.explainType !== null"
        >
          不需要讲解病因病机
        </div>
        <div>{{ dialecticalData.explainTitle }}</div>
        <div v-if="dialecticalData.explainContent">
          {{ dialecticalData.explainContent }}
        </div>

        <div class="c-g">
          <span class="c-l b-title">未关联辨证的症状：</span>
          <span class="c-v">{{ noRelationSymptomName || "无" }}</span>
        </div>

        <div class="c-g jl">
          <span class="c-l b-title">结论：</span>
          <span class="c-v value red">{{
            dialecticalData.conclusion || "无"
          }}</span>
        </div>

        <!-- 新病因病机 -->
        <div v-if="info.isNew === 1">
          <etiologyPathogenesis
            ref="etiologyPathogenesisRef"
            :dataInfo="JSON.parse(info.returnJson)"
            :info="info"
            isDetail
          />
        </div>
        <!-- 旧病因病机 -->
        <div v-else>
          <div class="b-title c-g">
            <span class="c-l">推理逻辑：</span>
          </div>

          <div class="c-g group">
            <span class="c-l">主诉：</span>
            <span
              class="c-v"
              v-for="(item, index) in etiologyDialectical2"
              :key="index"
              ><span v-html="item"></span
            ></span>
            <span class="c-v" v-if="!etiologyDialectical2.length">无</span>
          </div>

          <div class="group c-g" v-if="etiologyDialectical.length">
            <div class="content">
              <p v-for="(item, index) in etiologyDialectical" :key="index">
                <span class="c-v" v-html="item"></span>
              </p>
            </div>
          </div>

          <div class="group">
            <div>病情五行图：<span v-if="!tableData.length">无</span></div>
            <Table :data="tableData" :columns="columns1" border stripe>
              <template slot-scope="{ row }" slot="木">
                <Icon v-if="row.木" type="md-arrow-down" />
                {{ row.木 }}
              </template>
              <template slot-scope="{ row }" slot="火">
                <Icon v-if="row.火" type="md-arrow-down" />
                {{ row.火 }}
              </template>
              <template slot-scope="{ row }" slot="土">
                <Icon v-if="row.土" type="md-arrow-down" />
                {{ row.土 }}
              </template>
              <template slot-scope="{ row }" slot="金">
                <Icon v-if="row.金" type="md-arrow-down" />
                {{ row.金 }}
              </template>
              <template slot-scope="{ row }" slot="水">
                <Icon v-if="row.水" type="md-arrow-down" />
                {{ row.水 }}
              </template>
            </Table>
          </div>

          <div class="group">
            <div>辨证组合分析：<span v-if="!wxGroup.length">无</span></div>
            <div class="flex_between" v-if="wxGroup.length">
              <div class="table-black">
                <Table :data="wxGroup" :columns="columns2" border stripe>
                  <template slot-scope="{ row }" slot="木">
                    <div v-html="row.木"></div>
                  </template>
                  <template slot-scope="{ row }" slot="火">
                    <div v-html="row.火"></div>
                  </template>
                  <template slot-scope="{ row }" slot="土">
                    <div v-html="row.土"></div>
                  </template>
                  <template slot-scope="{ row }" slot="金">
                    <div v-html="row.金"></div>
                  </template>
                  <template slot-scope="{ row }" slot="水">
                    <div v-html="row.水"></div>
                  </template>
                </Table>
              </div>
              <div class="tip-info">
                <div class="tip-info-title">严重程度</div>
                <div class="tip-info-body">
                  <div class="tib-left"></div>
                  <div class="tib-right">
                    <span>高</span>
                    <span>低</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="c-g group">
            <span class="c-l">好转的症状表现：</span>
            <span class="c-v">
              <template
                v-if="
                  dialecticalData.betterSymptom &&
                  dialecticalData.betterSymptom.length
                "
              >
                <span
                  v-for="(item, index) in dialecticalData.betterSymptom"
                  :key="index"
                  >【{{ item }}】</span
                >
                趋向减轻；
              </template>
              <template
                v-if="
                  dialecticalData.disappearSymptom &&
                  dialecticalData.disappearSymptom.length
                "
              >
                <span
                  v-for="(item, index) in dialecticalData.disappearSymptom"
                  :key="index"
                  >【{{ item }}】</span
                >
                消失
              </template>
              <span
                v-if="
                  !(
                    dialecticalData.betterSymptom &&
                    dialecticalData.betterSymptom.length
                  ) &&
                  !(
                    dialecticalData.disappearSymptom &&
                    dialecticalData.disappearSymptom.length
                  )
                "
                >无</span
              >
            </span>
          </div>

          <div class="b-title c-g">
            <span class="c-l">总结：</span>
          </div>

          <div class="group c-g">
            <span class="c-l">病因可能性：</span>
            <span class="c-v">{{
              dialecticalData.etiologyPossible || "无"
            }}</span>
          </div>

          <div class="group c-g">
            <span class="c-l">好转脏腑：</span>
            <span class="c-v">
              <span
                v-if="
                  dialecticalData.betterViscera &&
                  dialecticalData.betterViscera.length
                "
                >{{ dialecticalData.betterViscera.join("、") }}</span
              >
              <span v-else>无</span>
            </span>
          </div>

          <template v-if="info.picUrl">
            <div class="mk-title">疾病发展推演图</div>
            <img class="pic" :src="picUrl(info.picUrl)" />
          </template>
        </div>
      </div>
      <div class="black-body" v-else>
        <el-empty></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import etiologyPathogenesis from "@/com/etiologicalAnalysis/com/etiologyPathogenesis.vue";
// import { useClipboard } from "@vueuse/core";
// const { copy } = useClipboard();
import copy from "copy-text-to-clipboard";

// 汉子长度按两个字符计算
String.prototype.length2 = function () {
  var cArr = this.match(/[^\x00-\xff]/gi);
  return this.length + (cArr == null ? 0 : cArr.length);
};

export default {
  components: {
    etiologyPathogenesis,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({ isNew: 0 }),
    },
    // 是否对比页
    isContrast: {
      type: Boolean,
      default: false,
    },
    cloudPic: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      dialecticalData: {},
      columns1: [
        {
          title: "  ",
          key: "label",
          width: 60,
          align: "center",
        },
        {
          title: "木",
          key: "木",
          minWidth: 100,
          slot: "木",
          align: "center",
        },
        {
          title: "火",
          key: "火",
          minWidth: 100,
          slot: "火",
          align: "center",
        },
        {
          title: "土",
          key: "土",
          minWidth: 100,
          slot: "土",
          align: "center",
        },
        {
          title: "金",
          key: "金",
          minWidth: 100,
          slot: "金",
          align: "center",
        },
        {
          title: "水",
          key: "水",
          minWidth: 100,
          slot: "水",
          align: "center",
        },
      ],
      columns2: [
        {
          title: "木",
          key: "木",
          minWidth: 100,
          slot: "木",
          align: "center",
        },
        {
          title: "火",
          key: "火",
          minWidth: 100,
          slot: "火",
          align: "center",
        },
        {
          title: "土",
          key: "土",
          minWidth: 100,
          slot: "土",
          align: "center",
        },
        {
          title: "金",
          key: "金",
          minWidth: 100,
          slot: "金",
          align: "center",
        },
        {
          title: "水",
          key: "水",
          minWidth: 100,
          slot: "水",
          align: "center",
        },
      ],
      wxGroup: [],
      wxGroup2: [],
      tableData: [],
      etiologyDialectical: [],
      etiologyDialectical2: [], //主诉信息
      noRelationSymptomName: "",
    };
  },
  computed: {
    isEmpty() {
      return !this.info.symptomNo;
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.init();
    },
    info() {
      this.init();
    },
  },
  methods: {
    picUrl(url) {
      return window.config.cloudPic + "/diseasemap/" + url;
    },
    close() {
      this.$emit("update:value", false);
    },
    init() {
      if (this.value) {
        let { etiologyDialecticalVOS, wx, wxGroup, dialecticalData } =
          this.info.dialecticalData;
        this.dialecticalData = this.info.dialecticalData;
        this.wxGroup = wxGroup ? this.formatWxGroup(wxGroup || []) : [];
        this.setEtiologyDialectical(etiologyDialecticalVOS || []);
        this.setTableData(wx || []);
        this.wxGroup2 = wxGroup ? this.formatWxGroup2(wxGroup || []) : [];
      }
    },
    // 辨证组合分析数据整理（复制用)
    formatWxGroup2(list) {
      let size = list.reduce((length, i) => {
        return i.bzName.length > length ? i.bzName.length : length;
      }, 0);
      let arr = [];
      for (let i = 0; i < size; i++) {
        let a = new Array(5).fill("");
        arr.push(a);
      }
      this.columns2.forEach((i, index) => {
        (list.find((j) => j.name == i.key)?.bzName || []).forEach(
          (j, index2) => {
            arr[index2][index] = j;
          }
        );
      });
      return arr;
    },
    formatWxGroup(list) {
      let obj = {};
      list.forEach((i) => {
        obj[i.name] = i.bzName.map((j) => `<div>${j}</div>`).join("");
      });
      return [obj];
    },
    setEtiologyDialectical(list) {
      this.noRelationSymptomName = list.length
        ? list[0].noRelationSymptomName
        : "";
      let symptomId = list.map((i) => i.symptomId);
      let ids = new Set(symptomId);
      let arr = [];
      ids.forEach((i) => {
        let arr2 = list.filter((j) => j.symptomId == i);
        let ids2 = new Set(arr2.map((o) => o.dialecticsId));
        let l = [];
        ids2.forEach((i) => {
          l.push(arr2.filter((j) => j.dialecticsId == i));
        });
        arr.push(l);
      });

      let strArr = [];
      let strArr2 = []; //保存主诉信息
      arr.forEach((j) => {
        let symptomName = j[0][0].symptomName;
        let isZs = this.info.diagnosticName1 == symptomName; //是否主诉
        let str = isZs
          ? `【<span class="red">${symptomName}</span>】`
          : `【${symptomName}】`;
        j.forEach((i) => {
          let s = isZs ? "这是由于" : "是由于";
          let sArr = [];
          i.forEach((j) => {
            let bottomReason = j.bottomReason
              ? JSON.parse(j.bottomReason).join(",")
              : "";
            let str = bottomReason ? (!isZs ? `（${bottomReason}）` : "") : "";
            sArr.push(
              `【${j.etiologyName}】${str}导致【${i[0].pathogenesisName}之${
                i[0].isTypical ? "典型" : "非典型"
              }】`
            );
          });
          s += `${sArr.join("、")}，中医叫做【${i[0].dialecticsName}】`;
          if (isZs) {
            //保存主诉信息
            strArr2.push(str + s + "。");
          } else {
            strArr.push(str + s + "。");
          }
        });
      });
      this.etiologyDialectical = strArr;
      this.etiologyDialectical2 = strArr2;
    },

    setTableData(list) {
      let yang = { label: "阳" };
      let yin = { label: "阴" };
      list.forEach((i) => {
        yang[i.name] = i.yang;
        yin[i.name] = i.yin;
      });
      this.tableData = [yang, yin];
    },
    getNodeValue(nodeList) {
      return nodeList
        ? nodeList
            .map((node) => {
              if (node.nodeType === 3) {
                return node.nodeValue;
              } else {
                return this.getNodeValue([...node.childNodes]);
              }
            })
            .join("")
        : "";
    },
    clone() {
      if (this.info.isNew === 1) {
        this.$refs.etiologyPathogenesisRef.downloadExcel();
      } else {
        this.clone2();
      }
    },
    clone2() {
      let arr = [];
      let cg = this.$el.querySelectorAll(".c-g");
      cg.forEach((i) => {
        let label = "",
          value = "";
        let lNode = i.querySelector(".c-l");
        if (lNode) {
          label = lNode.innerHTML;
        }
        let vNode = i.querySelectorAll(".c-v");
        if (vNode) {
          value = [...vNode].map((i) => this.getNodeValue([i])).join("\n");
        }
        arr.push(label + value);
      });

      // 获取五行图
      let cArr = [];
      this.tableData.forEach((i) => {
        cArr.push(
          this.columns1.map((j) => {
            let v = i[j.key];
            return /\d+/.test(v) && v > 0 ? "↓" + v : v;
          })
        );
      });
      arr.push("病情五行图：");
      arr.push(
        this.createTableStr(
          this.columns1.map((i) => i.title),
          cArr
        )
      );

      arr.push("辨证组合分析(严重程度:上高下低)：");
      arr.push(
        this.createTableStr(
          this.columns2.map((i) => i.title),
          this.wxGroup2
        )
      );

      let text = arr.join("\n");
      if (copy(text)) {
        this.$Message.success("复制成功");
      }
    },

    createTableStr(headers, rows) {
      let t = "-".repeat(100);
      // Calculate the maximum width of each column
      const columnWidths = headers.map((header, index) => {
        let width = header.length2();
        rows.forEach((row) => {
          const cell = row[index] + "";
          if (cell && cell.length2() > width) {
            width = cell.length2();
          }
        });
        return width < 15 ? 15 : width;
      });

      // Create the table header row
      let table = "+";
      columnWidths.forEach((width) => {
        table += t.slice(0, width + 2) + "+";
      });
      table += "\n";

      // Add headers
      table += "| ";
      headers.forEach((header, index) => {
        let w = (columnWidths[index] - header.length2()) / 2;
        const padding1 = " ".repeat(w);
        const padding2 = " ".repeat(w + (w % 2 ? 1 : 0));
        table += padding1 + header + padding2 + " |";
      });
      table += "\n";

      // Add the separator row
      table += "+";
      columnWidths.forEach((width) => {
        table += t.slice(0, width + 2) + "+";
      });
      table += "\n";

      // Add rows
      rows.forEach((row) => {
        table += "| ";
        row.forEach((cell, index) => {
          let w = (columnWidths[index] - (cell + "").length2()) / 2;
          const padding1 = " ".repeat(w);
          const padding2 = " ".repeat(w + (w % 2 ? 1 : 0));
          table += padding1 + cell + padding2 + " |";
        });
        table += "\n";
      });

      // Add the last separator row
      table += "+";
      columnWidths.forEach((width) => {
        table += t.slice(0, width + 2) + "+";
      });
      table += "\n";

      return table;
    },
    toTableStr() {},
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.commentary {
  z-index: 10;
  height: 100%;
  width: 100%;
  text-align: left;
  line-height: 2.5em;
  overflow: hidden;

  .block {
    height: 100%;
    display: flex;
    flex-direction: column;

    .black-body {
      height: 100%;
      padding: 15px;
    }

    .block-header {
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
  :deep {
    .header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .title {
        font-weight: bold;
        font-size: 16px;
      }

      .other {
        opacity: 0.7;
      }

      .right {
        display: flex;
        align-items: center;

        & > * {
          margin-left: 15px;
        }
      }
    }
    .etiology-pathogenesis {
      padding: 0;
    }
  }

  .close {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }
  }

  .ivu-card {
    margin-bottom: 15px;

    .ivu-card-head {
      padding: 8px 16px;
      background: #f5f5f5;

      p {
        font-size: 14px;
      }
    }
  }

  .b-title {
    font-weight: bold;
  }

  .group {
    padding-left: 20px;
    position: relative;
    margin-bottom: 10px;

    &::after {
      content: " ";
      display: block;
      clear: both;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      left: 0;
      top: 14px;
    }
  }

  .red {
    color: #f00;
    font-style: normal;
  }

  .ivu-table-cell {
    height: auto !important;
  }

  .treatment-progress {
    background: none;

    .ivu-progress-inner {
      background: #f5f5f5;
    }
  }

  .tip-info {
    width: 120px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tip-info-body {
      height: 100%;
      display: flex;

      .tib-left {
        border-right: 1px solid #ccc;
        width: 10px;
        margin-right: 15px;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 9px;
          height: 9px;
          position: absolute;
          border: 1px solid #ccc;
          border-width: 1px 0 0 1px;
          right: -5px;
          transform: rotate(45deg);
        }
      }

      .tib-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }

  .table-black {
    // width: 100%;
    width: calc(100% - 100px);
  }

  .flex_between {
    display: flex;
    justify-content: space-between;
  }

  .pic {
    max-width: 100%;
  }

  .mk-title {
    font-weight: bold;
    text-align: center;
  }

  .el-empty {
    height: 100%;
  }
}
</style>
